module.exports = __webpack_public_path__ + "img/daily_public_cost.2d7d800f.png";